import { useEffect, useState } from "react"
import { showErrorModal } from "utils/Modals"

type Props<T> = {
    message: string,
    task: () => Promise<T>,
    onSuccess: (result: T) => void,
    onError: (error: any) => void,
    onComplete: () => void
}

export function LoadingToast<T>({ message, onSuccess, onComplete, onError, task }: Props<T>) {
    const [error, setError] = useState<string | null>()

    useEffect(() => {
        doTask()
    }, [])

    const doTask = async () => {
        try {
            onSuccess(await task())
            setError(null)
        } catch (e: any) {
            onError(e)
            setError(`${(typeof (e) == 'string' ? e : (('message' in e || 'error' in e) ? (e.message ?? e.error) : JSON.stringify(e)))}`)
        } finally {
            onComplete()
        }
    }

    return <div>
        <div
            className="bs-toast toast m-2 show bg-white"
            role="alert">

            {
                error !== undefined && <div className="toast-header">
                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            }

            <div className="toast-body">
                {
                    error === undefined && <div className="badge bg-label-primary me-2 ">
                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                            <i className="bx bx-check visually-hidden"></i>
                        </div>
                    </div>
                }

                {
                    error === null && <div className="badge bg-label-success me-2 ">
                        <i className="bx bx-check-double"></i>
                    </div>
                }

                {
                    error && <div onClick={() => showErrorModal(error)} className="badge bg-label-danger me-2 cursor-pointer">
                        <i className="bx bx-error-circle"></i>
                    </div>
                }

                <span className="fw-semibold">{message} ...</span>
            </div>
        </div>
    </div>
}